import { render, staticRenderFns } from "./SecondaryTranscript.vue?vue&type=template&id=01d3821a&"
import script from "./SecondaryTranscript.vue?vue&type=script&lang=js&"
export * from "./SecondaryTranscript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports